<template>
  <div>
    <jet-nav-link
      :href="route('home')"
      :active="route().current('home')"
    >
      Dashboard
    </jet-nav-link>
    <jet-nav-link
      :href="route('entrevista.index')"
      :active="route().current('entrevista.index')"
    >
      Entrevista
    </jet-nav-link>
    <nav-link-dropdown
      label="Cadastro"
      :active="[
                    'user.index',
                    'user.create',
                    'user.edit',
                    'centro-custo.index',
                 ].includes($page.currentRouteName)"
    >
      <div class="block px-4 py-2 text-xs text-gray-400">
        Diversos
      </div>
      <jet-dropdown-link :href="route('accesscontrol.index')">
        Controle de Acesso
      </jet-dropdown-link>
      <jet-dropdown-link :href="route('user.index')">
        Usuário
      </jet-dropdown-link>
      <jet-dropdown-link :href="route('centro-custo.index')">
        Centro de Custo
      </jet-dropdown-link>
    </nav-link-dropdown>
  </div>
</template>

<script>
import JetDropdown from '@/Jetstream/Dropdown'
import JetDropdownLink from '@/Jetstream/DropdownLink'
import JetNavLink from '@/Jetstream/NavLink'
import NavLinkDropdown from '@/Components/NavLinkDropdown';

export default {
  components: { JetDropdown, JetNavLink, JetDropdownLink, NavLinkDropdown }

}
</script>

<style>
</style>
